import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import ContratCreation from "../../../components/Admin/Contrat/ContratCreation";
import ActiviteCreation from "../../../components/Admin/Activtes/ActiviteCreation";
import ActivitesVue from "../../../components/Admin/Activtes/ActivitesVue";
import {fetchToGetActivitesAdmin} from "../../../services/ActivitesService";

function AdminActivitesPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const {entrepriseId, contratId} = useParams();
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const modeOptions = {
        'creation': <ActiviteCreation />,
        'consultation': <ActivitesVue />,
        'default': <ActivitesVue />
    }
    const ComponentToRender = modeOptions[mode] || modeOptions['default'];

    return (
        <div className="content_tab">
            <TitleMain text="Activités"/>

            { ComponentToRender }
        </div>
    )
}

export default AdminActivitesPage;
